import { orderChatList, clearNoMessageList } from "./helpers";

import { apiInitState, reducerApiConstructor } from "../helpers";

const apiReducers = reducerApiConstructor("chat");

export const chatInitState = {
  init: false,
  currentChat: {
    messages: [],
    hasAccepted: true,
    isChatRequest: false,
    newChat: false,
    inputDisabled: false,
    firstMessage: null,
    info: {
      name: null,
      surname: null,
      profilePicture: null,
    },
  },
  lastChatOpen: null,

  chatList: {},
  api: apiInitState,
};

export const chatReducers = {
  setInit: (state) => {
    state.init = true;
  },

  setCurrentChat: (state, { payload }) => {
    state.currentChat.hasAccepted = payload.hasAccepted;
    state.currentChat.isChatRequest = payload.isChatRequest;
    state.currentChat.newChat = payload.newChat;
    if (payload.messages) {
      state.currentChat.messages = payload.messages;
    }

    state.currentChat.chatId = payload.chatId;
    state.currentChat.firstMessage = payload.firstMessage;
  },

  setCurrentChatInfo: (state, { payload }) => {
    state.currentChat.info = payload;
  },

  setFullChatList: (state, { payload }) => {
    state.chatList = orderChatList(payload);
    state.init = true;
  },

  appendChatToChatList: (state, { payload }) => {
    const { chat } = payload;
    const newChat = { [chat.chatId]: chat };

    state.chatList = orderChatList({ ...state.chatList, ...newChat });
  },

  updateChatListInfo: (state, { payload }) => {
    const { id, data } = payload;

    if (state.chatList[id]) {
      state.chatList[id] = { ...state.chatList[id], ...data };
      state.chatList = orderChatList(state.chatList);
    }
  },

  clearChatInfo: (state) => {
    state.currentChat.info = {
      name: null,
      surname: null,
      profilePicture: null,
    };
    state.currentChat.newChat = false;
    state.currentChat.hasAccepted = true;
    state.currentChat.init = false;
    state.currentChat.messages = [];
    state.chatList = clearNoMessageList(state.chatList);
  },

  setDisabledInputState: (state, { payload }) => {
    state.currentChat.inputDisabled = payload;
  },

  setMessages: (state, { payload }) => {
    state.currentChat.messages = payload;
  },

  setChatId: (state, { payload }) => {
    state.currentChat.chatId = payload;
  },

  // redux
  init: () => {},
  goToCurrentChatProfile: () => {},
  goToProfile: () => {},
  getChatMessages: () => {},
  getChatMenuInfo: () => {},
  sendFirstMessage: () => {},
  initNewChat: () => {},
  removeChatFromList: () => {},
  openChat: () => {},
  changeChat: () => {},
  sendMessage: () => {},
  acceptChatInvitation: () => {},
  rejectChatInvitation: () => {},
  readMessages: () => {},
  deleteCurrentChat: (state, { payload }) => {},
  ...apiReducers,
};
